module.exports = __webpack_public_path__ + "static/media/16x20.8ce3e0d6.png";